import React from 'react';
import { StyleSheet } from 'react-native';

import {
  GroupOrderModal,
  GroupOrderModalContent,
  GroupOrderModalContentBlock,
  GroupOrderModalScrollView,
} from '@order/features/group-ordering';

import { SignedOutViewContent } from '../SignedOutView';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderSignedOutModal = (props: Props) => {
  const { redirectTo, onClose } = props;

  return (
    <GroupOrderModal onClose={onClose}>
      <GroupOrderModalContent>
        <GroupOrderModalScrollView contentContainerStyle={styles.scrollContent}>
          <GroupOrderModalContentBlock style={styles.contentBlock}>
            <SignedOutViewContent redirectTo={redirectTo} />
          </GroupOrderModalContentBlock>
        </GroupOrderModalScrollView>
      </GroupOrderModalContent>
    </GroupOrderModal>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  scrollContent: {
    flexGrow: 1,
  },
  contentBlock: {
    flex: 1,
    justifyContent: 'center',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  redirectTo?: string;
  onClose: () => void;
};
